const ns = "ACCOUNTS";
export const ERROR = `${ns}_ERROR`;
